<template>
  <div class="office-home container">
    <div v-if="loading" style="min-height: 1000px">
      <div class="row margin-bottom-10 margin-top-20 mybookings-header">
        <div class="col-12">
          <div class="card afas-gold">
            <div class="card-content">
              <h5 class="margin-top-10 margin-bottom-10 white-text">Manage Offices</h5>
              <a class="waves-effect waves-light white teal-text btn-small btn-block back-button" @click="goBack">Go Back</a>
            </div>
          </div>
          <div class="progress">
            <div class="indeterminate"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading">
      <div class="row margin-bottom-10 margin-top-20">
        <div class="col-12">
          <div class="card afas-gold">
            <div class="card-content">
              <h5 class="margin-top-10 margin-bottom-10 white-text">Manage Offices</h5>
              <a class="waves-effect waves-light white teal-text btn-small btn-block back-button" @click="goBack">Go Back</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row offices">
        <div class="col s12">
            <table class="table striped">
                <thead>
                    <th>Rank</th>
                    <th>Name</th>
                    <th>Location</th>
                    <th>Desks</th>
                    <th>Limit</th>
                </thead>
                <tbody>
                    <tr v-for="office in allOffices" :key="office.officeid">
                        <td style="width: 50px;">
                            <input type="text" v-model="office.officeid" @blur="updateOfficeStart(office)" :disabled="processing" />
                        </td>
                        <td>
                            <input type="text" v-model="office.naam" @blur="updateOfficeStart(office)" :disabled="processing"/>
                        </td>
                        <td>
                            <input type="text" v-model="office.locatie" @blur="updateOfficeStart(office)" :disabled="processing"/>
                        </td>
                        <td style="width: 150px;">
                            <input type="number" v-model="office.plekken" @blur="updateOfficeStart(office)" :disabled="processing"/>
                        </td>
                        <td style="width: 150px;">
                            <input type="number" v-model="office.limiet" @blur="updateOfficeStart(office)" :disabled="processing"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Offices",
  data() {
    return {
      loading: true,
      processing: false
    };
  },
  computed: mapGetters(["allOffices"]),
  methods: {
    ...mapActions(["getAllOffices", "updateOffice"]),
    async updateOfficeStart(office){
        if(office.plekken && office.locatie && office.naam && office.officeid){
            this.processing = true;
            await this.updateOffice(office);
            await this.getAllOffices();
            this.processing = false;
        } else {
            console.log("Er missen gegevens!")
        }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  async created() {
    await this.getAllOffices();
    this.loading = false;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .office-home .back-button {
        position: absolute;
        top: 15px;
        right: 15px;;
    }
</style>



// WEBPACK FOOTER //
// src/components/offices/allOffices.vue